import { useTranslation } from "react-i18next";

import { ForgotPasswordForm } from "../components";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/v2/card";

function ForgotPasswordPage() {
  const { t } = useTranslation();

  return (
    <Card className="w-full max-w-lg mx-auto shadow-lg">
      <CardHeader className="space-y-2 pb-4">
        <CardTitle>{t("auth.pages.forgotPassword.title")}</CardTitle>
        <CardDescription>
          {t("auth.pages.forgotPassword.subHeader")}
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <ForgotPasswordForm />
      </CardContent>
    </Card>
  );
}

export default ForgotPasswordPage;
